import styles from "../styles/CapsuleCounter.module.css";

const CapsuleCounter = ({ increment, setIncrement }) => {
    return (
        <div className={`${styles.capsule} my-auto`}>
            <span
                className={styles.minus}
                onClick={() =>
                    increment > 0 ? setIncrement(increment - 1) : ""
                }
            >
                -
            </span>
            <div className={styles.vertical}></div>
            <span className={styles.count}>{increment}</span>
            <div className={styles.vertical}></div>
            <span
                className={styles.plus}
                onClick={() =>
                    increment < 4 ? setIncrement(increment + 1) : ""
                }
            >
                +
            </span>
        </div>
    );
};

export default CapsuleCounter;
